import { Directive, HostBinding, Input } from '@angular/core';
import { OPAStatusDesc } from '../interfaces/opa-status-desc.interface';

@Directive({
  selector: '[siAuthorisationStatus]',
  standalone: true,
})
export class AuthorisationStatusDirective {
  private _isAuthorised: boolean;

  @Input()
  set siAuthorisationStatus(element: { status?: OPAStatusDesc }) {
    this._isAuthorised = element.status === OPAStatusDesc.Authorised;
  }

  @HostBinding('style.color')
  get textColor(): string {
    return this._isAuthorised ? '#018478' : '';
  }
}